module.exports = __webpack_public_path__ + "static/netlify-02-7f1e697885558d342fb5c39f0d20aaf4.png";